<template>
  <div class="bottomNav">
    <el-row>
      <el-col :span="3">
        <div class="grid-content">1</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <Logo></Logo>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="grid-content">
          <el-row>
            <el-col :span="4">
              <div class="grid-content">
                <h1><router-link to="/dongximuying">
                  <div id="contactUs" @click="backtop">关于我们</div>
                </router-link></h1>
                <p><router-link to="/dongximuying">
                  <div id="contactUs" @click="backtop">公司简介</div>
                </router-link></p>
                <p><router-link to="/kaenjianjie">
                  <div id="contactUs" @click="backtop">大事记</div>
                </router-link></p>
                <p><router-link to="/yewufanwei">
                  <div id="contactUs" @click="backtop">业务范围</div>
                </router-link></p>
                <p><router-link to="/supplychain">
                  <div id="contactUs" @click="backtop">供应链体系</div>
                </router-link></p>
                <p><router-link to="/gongsirongyu">
                  <div id="contactUs" @click="backtop">公司荣誉</div>
                </router-link></p>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <h1><router-link to="IPyingxiao">
                  <div id="contactUs" @click="backtop">IP营销</div>
                  </router-link></h1>
                <p><router-link :to="{name:'IPyingxiao',params:{aa:1}}">
                  <div id="contactUs" @click="backtop">IP生态聚合</div>
                  </router-link></p>
                <p><router-link to="/celuechuangyi">
                  <div id="contactUs" @click="backtop">IP创意设计</div>
                </router-link></p>
                <p><router-link to="/kehuanli">
                  <div id="contactUs" @click="backtop">整合优势资源</div>
                </router-link></p>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <h1><router-link to="/chanpinjieshao">
                  <div id="contactUs" @click="backtop">产品介绍</div>
                </router-link></h1>
                <!-- <p><router-link :to="{name:'chanpinjieshao',params:{a:0}}" id="anjia1">
                  <div id="contactUs" @click="backtop">安佳奶片机</div>
                  </router-link></p>
                <p><router-link :to="{name:'chanpinjieshao',params:{a:1}}" id="xiaowanju1">
                  <div id="contactUs" @click="backtop">KFC超级飞侠...</div>
                  </router-link></p>
                <p><router-link :to="{name:'chanpinjieshao',params:{a:2}}" id="laganxiang1">
                  <div id="contactUs" @click="backtop">米奇亲自拉...</div>
                  </router-link></p>
                <p><router-link :to="{name:'chanpinjieshao',params:{a:3}}" id="lanya1">
                  <div id="contactUs" @click="backtop">米奇Magic...</div>
                  </router-link></p> -->
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <h1><router-link to="/kehuanli">
                  <div id="contactUs" @click="backtop">客户案例</div>
                </router-link></h1>
                <!-- <p><router-link :to="{name:'kehuanli',params:{b:3}}" id="xiaohuangren1">2018年KFC圣诞...</router-link></p>
                <p><router-link :to="{name:'kehuanli',params:{b:2}}" id="shiziwang1">狮子王真人版电...</router-link></p>
                <p><router-link :to="{name:'kehuanli',params:{b:0}}" id="baishi1">2019年百事可乐...</router-link></p>
                <p><router-link :to="{name:'kehuanli',params:{b:1}}" id="anjianai1">2019年安佳奶片...</router-link></p> -->
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <h1><router-link :to="{name:'About',params:{c:'first'}}">
                  <div id="contactUs" @click="backtop">联系我们</div>
                  </router-link></h1>
                <p><router-link :to="{name:'About',params:{c:'first'}}" id="lianxiwomen1">联系我们</router-link></p>
                <p><router-link :to="{name:'About',params:{c:'second'}}" id="jiaruwomen1">加入我们</router-link></p>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">
          <div class="bottomName">
            <span>
              上海卡恩文化传播股份有限公司 ©2021 SHANGHAI COUNTON CO., LTD. 沪ICP备20014655号-1
            </span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Logo from './Logo'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: { Logo },
  methods: {
    backtop() {
      document.documentElement.scrollTop = 0;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bottomName span{
  // font-family: "微软雅黑" !important;
  color: #b6b6b6 !important;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
}
.bottomNav {
  background-color: #333333;
  padding-bottom: 28px;
  padding-top: 55px;
  h1 {
    font-size: 20px;
    color: #ffffff;
    // font-family: "微软雅黑";
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    margin: 0 0 20px 0;
  }
  p {
    font-size: 14px;
    color: #b6b6b6;
    text-align: left;
    // font-family:"微软雅黑" !important;
    font-weight:300;
  }
  .bottomName {
    margin-top: 64px;
    span {
      color: #ffffff;
      font-size: 15px;
      text-align: center;
      width: 100%;
      // font-family:"微软雅黑";
      font-weight:400;
    }
  }
}
h1 a{
  color: #fff;
}
a {
  text-decoration: none;
  color: #b6b6b6;
}
</style>
